import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const PhotoInfoStep: React.FC = () => {
  const { goNext, goBack } = useWizard();
  const [title, setTitle] = useState('Information om pasfoto');
  const [body, setBody] = useState<string[]>([
    'Et nyt pas kræver et biometrisk pasfoto, der overholder strenge krav.'
  ]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.photo_info).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title={title}>
      <InfoBox type="info">
        {body.map((p, i) => <p key={i}>{p}</p>)}
      </InfoBox>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default PhotoInfoStep;
